import { z } from "zod";

import { emailSchema } from "./idpDiscovery";

const DISCOVER_PATH = "/auth/discover";

const ssoDiscoverySchema = z.object({
  ssoEnabled: z.boolean(),
  cognitoDomain: z.string().min(1),
  cognitoClientId: z.string().min(1),
  cognitoIdentityProvider: z.string().min(1),
});

type SsoDiscoveryConfig = z.infer<typeof ssoDiscoverySchema>;

export const getDiscoverSsoUrl = (apiUrl: string): string =>
  `${apiUrl.replace(/\/$/, "")}${DISCOVER_PATH}`;

type DiscoverSsoResult =
  | { status: "found"; config: SsoDiscoveryConfig }
  | { status: "not-found" }
  | { status: "error"; message: string };

export const discoverSsoConfig = async (
  email: string,
): Promise<DiscoverSsoResult> => {
  const parsed = emailSchema.safeParse(email);
  if (!parsed.success) {
    return { status: "not-found" };
  }

  try {
    const response = await fetch(
      getDiscoverSsoUrl(`${process.env.REACT_APP_API_URL}`),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: parsed.data }),
      },
    );

    if (!response.ok) {
      return { status: "not-found" };
    }

    const parsedConfig = ssoDiscoverySchema.safeParse(
      (await response.json()) as unknown,
    );

    if (!parsedConfig.success || !parsedConfig.data.ssoEnabled) {
      return { status: "not-found" };
    }

    return { status: "found", config: parsedConfig.data };
  } catch (err) {
    return {
      status: "error",
      message: err instanceof Error ? err.message : "Unknown discovery error",
    };
  }
};
